module.exports = __webpack_public_path__ + "static/media/happy clienrt-01-01.99dc4538.svg";